import {
  ADD_INVENTORY_REQUESTED,
  ADD_INVENTORY_SUCCESS,
  ADD_INVENTORY_FAILURE,
  SUBTRACT_INVENTORY_REQUESTED,
  SUBTRACT_INVENTORY_SUCCESS,
  SUBTRACT_INVENTORY_FAILURE,
  SET_INVENTORY_REQUESTED,
  SET_INVENTORY_SUCCESS,
  SET_INVENTORY_FAILURE,
  SCAN_INVENTORY_REQUESTED,
  SCAN_INVENTORY_SUCCESS,
  SCAN_INVENTORY_FAILURE,
  ADD_PLACEHOLDER_ACTION,
  TRANSFER_INVENTORY_REQUESTED,
  TRANSFER_INVENTORY_SUCCESS,
  TRANSFER_INVENTORY_FAILURE,
  LOAD_SESSION_EVENTS,
  CLEAR_SESSION,
  CLEAR_ACTION,
  SAVE_SESSION_CSV_REQUESTED,
  SAVE_SESSION_CSV_SUCCESS,
  SAVE_SESSION_CSV_FAILURE,
} from '../types';


const INITIAL_STATE = {
  isFetching: false,
  events: [],
  fetchingList: [],
  status: 'waiting',
  errors: null
};

const inventorySessions = (state = INITIAL_STATE, action) => {
  const newState = { ...state };


  switch(action.type) {
    case ADD_PLACEHOLDER_ACTION:
      let eventLength = state.events.length;

      return Object.assign({}, state, {
        events: [...state.events, { actionType: action.actionType, sku: action.barcode, placeholder: true, actionId: eventLength }],
        fetchingList: [...state.fetchingList, eventLength]
      });

    case ADD_INVENTORY_SUCCESS:
    
    case SUBTRACT_INVENTORY_SUCCESS:
    case SET_INVENTORY_SUCCESS:
    case TRANSFER_INVENTORY_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.errors = null;
      if(newState.events[action.payload.actionId]){
        newState.events[action.payload.actionId] = action.payload.item;
        newState.events[action.payload.actionId].actionType = action.payload.actionType;
        newState.events[action.payload.actionId].actionQuantity = action.payload.action_quantity || '';
        newState.events[action.payload.actionId].locationName = action.locationName;
      }

      newState.fetchingList = newState.fetchingList.filter(item => item !== action.payload.actionId);

      localStorage.setItem("liveInventorySession", JSON.stringify(newState.events));
      return newState;

    case SCAN_INVENTORY_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.errors = null;
      if(newState.events[action.payload.actionId]){
        newState.events[action.payload.actionId] = action.payload.item[0];
        newState.events[action.payload.actionId].actionType = action.payload.actionType;
        newState.events[action.payload.actionId].actionQuantity = action.payload.action_quantity || '';
        newState.events[action.payload.actionId].locationName = action.locationName;
      }

      newState.fetchingList = newState.fetchingList.filter(item => item !== action.payload.actionId);

      localStorage.setItem("liveInventorySession", JSON.stringify(newState.events));
      return newState;

    case ADD_INVENTORY_FAILURE:
    case SET_INVENTORY_FAILURE:
    case SCAN_INVENTORY_FAILURE:
    case SUBTRACT_INVENTORY_FAILURE:
    case TRANSFER_INVENTORY_FAILURE:
      newState.isFetching = false;
      newState.status = 'waiting';
      newState.errors = action.error.error;
      if(newState.events[action.error.actionId]){
        newState.events[action.error.actionId] = action.error;
      }

      newState.fetchingList = newState.fetchingList.filter(item => item !== action.error.actionId);

      localStorage.setItem("liveInventorySession", JSON.stringify(newState.events));
      return newState;

    case ADD_INVENTORY_REQUESTED:
    case SUBTRACT_INVENTORY_REQUESTED:
    case SET_INVENTORY_REQUESTED:
    case SCAN_INVENTORY_REQUESTED:
    case TRANSFER_INVENTORY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        errors: null,
      });

    case LOAD_SESSION_EVENTS:
      newState.events = action.events;
      return newState;

    case CLEAR_SESSION:
      localStorage.removeItem("liveInventorySession");
      return INITIAL_STATE;

    case CLEAR_ACTION:
      newState.errors = 'No value set';
      newState.events[action.actionId] = 'No value set';

      localStorage.setItem("liveInventorySession", JSON.stringify(newState.events));
      return newState;

    default:
      return state;
  }
}

export default inventorySessions;